import React, { useState } from "react";
import { FiSearch, FiGrid, FiPlus, FiBox, FiSettings, FiImage, FiDownload, FiLayers, FiUpload, FiMoreVertical } from "react-icons/fi";
import { Tabs, Spin, Dropdown as AntDropdown, Menu } from "antd";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import { ProductsHeader } from "../../components/Headers/Headers";
import ProductDetailsModal from "../../components/modals/ProductDetailsModal";
import PageName from "../../components/react_helmet/PageName";
import ItemsTable from "../../components/table/ItemsTable";
import useProducts from "./customHooks/useProducts";
import MergingProducts from "../../components/modals/MergingProducts";
import ImportDnhProductsModal from "../../components/modals/ImportDnhProductsModal";
import UploadProductsExcelModal from "../../components/modals/UploadProductsExcelModal";
import ImportMadePCProductsModal from "../../components/modals/ImportMadePCProductsModal";
import { BulkHumanizeProductsModal } from "../../components/modals/BulkHumanizeModal";

const Products = (props) => {
  const {
    searchValue,
    setSearchValue,
    products,
    status,
    setStatus,
    selectedData,
    setSelectedData,
    createItemModal,
    setCreateItemModal,
    toggleCreateModal,
    selectedProduct,
    setSelectedProduct,
    showItemModal,
    toggleShowItemModal,
    user, totalPages,
    page, setPage, pageSize, setPageSize, loading, gettingProducts, toggleMergeModal, mergeItemModal
  } = useProducts(props);

  const [importModal, setImportModal] = useState(false);
  const toggleImportModal = () => setImportModal(!importModal);

  const [imageUrlModal, setImageUrlModal] = useState(false);
  const [importProductsModal, setImportProductsModal] = useState(false);
  const [uploadExcelModal, setUploadExcelModal] = useState(false);
  const toggleUploadExcelModal = () => setUploadExcelModal(!uploadExcelModal);
  const [importMadePCModal, setImportMadePCModal] = useState(false);
  const toggleImportMadePCModal = () => setImportMadePCModal(!importMadePCModal);
  const [bulkHumanizeModal, setBulkHumanizeModal] = useState(false);
  const toggleBulkHumanizeModal = () => setBulkHumanizeModal(!bulkHumanizeModal);

  return (
    <div className="settings-container">
      <BulkHumanizeProductsModal 
        isOpen={bulkHumanizeModal} 
        toggle={toggleBulkHumanizeModal} 
        initialItems={selectedData} 
        refreshData={gettingProducts} 
      />
      <ImportMadePCProductsModal isOpen={importMadePCModal} toggle={toggleImportMadePCModal} onSuccess={gettingProducts} />
      <UploadProductsExcelModal isOpen={uploadExcelModal} toggle={toggleUploadExcelModal} />
      <MergingProducts modal={mergeItemModal} toggle={toggleMergeModal} />
      <ImportDnhProductsModal modal={importModal} toggle={toggleImportModal} />
      <ProductDetailsModal modal={showItemModal} newItem={selectedProduct} toggle={toggleShowItemModal} />

      <PageName title={"Products"} />

      <div className="px-4">
        <ProductsHeader
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          status={status}
          setStatus={setStatus}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          createItemModal={createItemModal}
          setCreateItemModal={setCreateItemModal}
          toggleCreateModal={toggleCreateModal}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          user={user}
          data={products}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={pageSize}
          loading={loading}
          gettingProducts={gettingProducts}
          toggleMergeModal={toggleMergeModal}
          toggleImportModal={toggleImportModal}
          setImageUrlModal={setImageUrlModal}
          imageUrlModal={imageUrlModal}
          importProductsModal={importProductsModal}
          setImportProductsModal={setImportProductsModal}
          toggleUploadExcelModal={toggleUploadExcelModal}
          toggleImportMadePCModal={toggleImportMadePCModal}
          toggleBulkHumanizeModal={toggleBulkHumanizeModal}
        />

        <div className="settings-card">
          {loading && (!products || products.length === 0) ? (
            <TableSkeleton columns={10} />
          ) : (
            <ItemsTable
              products={products}
              status={status}
              setSelectedData={setSelectedData}
              setSelectedProduct={setSelectedProduct}
              toggleCreateModal={toggleCreateModal}
              toggleShowItemModal={toggleShowItemModal}
              user={user}
              searchValue={searchValue}
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              pageSize={pageSize}
              setPageSize={setPageSize}
              gettingProducts={gettingProducts}
              onClearSearch={searchValue ? () => {
                setSearchValue("");
                setPage(1);
              } : undefined}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Products;
